@let isLoading = $isLoading();
@let isUnconfirmed = $isUnconfirmed();
<unity-outside-container>
  <kendo-stacklayout #contents class="outside-form" orientation="vertical" [gap]="15">
    @if (isUnconfirmed) {
      <h5>Your account has not been confirmed.</h5>
      <button
        kendoButton
        themeColor="primary"
        routerLink="/resend-confirm"
        type="button"
        [queryParams]="{ username: loginForm.controls.username.value }">
        Request New Confirmation Email
      </button>
      <button kendoButton themeColor="tertiary" type="button" (click)="reset()">Back to Login</button>
    } @else {
      <form id="loginForm" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <kendo-stacklayout orientation="vertical" [gap]="2">
          <unity-textbox-control
            displayName="Email"
            description="Enter your email address."
            [showHint]="false"
            [control]="loginForm.controls.username" />
          <unity-textbox-control
            placeholder="Password"
            type="password"
            displayName="Password"
            description="Enter your password."
            [showHint]="false"
            [clearButton]="true"
            [control]="loginForm.controls.password" />
          <button kendoButton themeColor="primary" class="login-button" type="submit" [disabled]="loginForm.invalid || isLoading">
            @if (!isLoading) {
              Sign In
            } @else {
              <kendo-loader type="infinite-spinner" size="small" themeColor="info" />
            }
          </button>
        </kendo-stacklayout>
      </form>
      <button kendoButton themeColor="tertiary" routerLink="/reset-password" type="button">Forgot Password?</button>
    }
  </kendo-stacklayout>
</unity-outside-container>
